import {
  selectRoleChangeRequest,
  useHMSActions,
  useHMSStore,
} from "@100mslive/react-sdk";
import type { ProviderRoleChange } from "../types";
import { convertHMSPeerToPeer } from "./helpers";

export const useHMSRoleChange = (): ProviderRoleChange => {
  const hmsActions = useHMSActions();
  const changeRoleRequest = useHMSStore(selectRoleChangeRequest);
  const requestedBy = changeRoleRequest?.requestedBy;
  const requestRoleChange = (peerId: string, role: string, force = false) =>
    hmsActions.changeRoleOfPeer(peerId, role, force);
  const acceptRoleChange = () =>
    changeRoleRequest && hmsActions.acceptChangeRole(changeRoleRequest);
  const rejectRoleChange = () =>
    changeRoleRequest && hmsActions.rejectChangeRole(changeRoleRequest);

  return {
    hasRoleChangeRequest: !!changeRoleRequest,
    requestedByPeer: requestedBy ? convertHMSPeerToPeer(requestedBy) : null,
    requestRoleChange,
    acceptRoleChange,
    rejectRoleChange,
  };
};
